export const CommonPecCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Gestione PEC',
    path: '/sistema/pec',
  },
];
